'use client';

import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { Collapse, Group, Stack, Text, UnstyledButton } from '@mantine/core';
import { useStore } from '@/stores';
import { IconButton } from '@/ui';
import { Icon } from '@/ui/Icon';
import { NavbarButton } from './NavbarButton';
import navbarButtonClasses from './NavbarButton.module.css';

const CALENDAR_PATH = '/calendar';
const SUBMENU_PATHS = [CALENDAR_PATH, '/posts'];

export const CalendarMenuItem = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const store = useStore();
  const pathname = location.pathname;

  const isSubmenuRoute = SUBMENU_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
  const isCalendarActive = pathname === CALENDAR_PATH;

  const [expanded, setExpanded] = useState(isSubmenuRoute);

  useEffect(() => {
    if (isSubmenuRoute) {
      setExpanded(true);
    }
  }, [isSubmenuRoute]);

  const onCalendarLinkClick = useCallback(() => {
    if (store.isMobile) {
      store.navbar.toggle();
    }
  }, [store]);

  return (
    <Stack gap={0}>
      <Group
        gap={0}
        wrap="nowrap"
        align="center"
        justify="space-between"
        className={navbarButtonClasses.navbarButton}
        data-active={isCalendarActive ? true : undefined}
      >
        <UnstyledButton
          component={Link}
          to={CALENDAR_PATH}
          onClick={onCalendarLinkClick}
          style={{ flex: 1, minWidth: 0 }}
        >
          <Group gap="2xs" align="center" wrap="nowrap">
            <Icon name="calendar" p={0} color="var(--mantine-color-text)" />
            <Text size="sm" fw={400}>
              {t('navbar.calendar')}
            </Text>
          </Group>
        </UnstyledButton>
        <IconButton
          iconName={expanded ? 'chevronDown' : 'chevronRight'}
          variant="subtle"
          size="sm"
          aria-label={
            expanded ? t('navbar.collapse-calendar-menu') : t('navbar.expand-calendar-menu')
          }
          aria-expanded={expanded}
          onClick={() => setExpanded((prev) => !prev)}
        />
      </Group>
      <Collapse expanded={expanded}>
        <Stack gap={0}>
          <NavbarButton label={t('navbar.calendar')} icon="calendar" href={CALENDAR_PATH} pl="lg" />
          <NavbarButton
            label={t('navbar.publish-queue')}
            icon="send"
            href="/posts/pending-publish"
            pl="lg"
          />
          <NavbarButton label={t('navbar.all-posts')} icon="article" href="/posts" pl="lg" />
        </Stack>
      </Collapse>
    </Stack>
  );
};
